<app-grid-table
  [loading]="loading"
  [columns]="columns"
  [datasource]="datasource"
  [rowModelType]="'infinite'"
  [showSearch]="false"
/>
